import React, { useState, useEffect } from "react";
import { FiTrash } from "react-icons/fi";
import "react-resizable/css/styles.css";
import Button from "../../../../../../app/components/Button";
import AddPanel from "../../../../../../forms/FormPanel/AddPanel";
import AddGraphic from "../../../../../../forms/FormPanel/AddGraphic";
import GraphicCard from "../../../../../../app/components/GraphicCard";
import FormServiceDelete from "../../../../../../forms/FormPanel/DeleteGraphic";
import Toast from "../../../../../../app/components/Toast";


const Panel = () => {
  const [panels, setPanels] = useState([]);
  const [activePanelIndex, setActivePanelIndex] = useState(null);
  const [graphicsByPanel, setGraphicsByPanel] = useState({});
  const [graphicStarsByPanel, setGraphicStarsByPanel] = useState({});
  const [graphicsDimensionsByPanel, setGraphicsDimensionsByPanel] = useState({});

  const [isAddPainelOpen, setIsAddPainelOpen] = useState(false);
  const [isAddGraphicOpen, setIsAddGraphicOpen] = useState(false);
  const [graphicToDeleteIndex, setGraphicToDeleteIndex] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const [panelToDeleteIndex, setPanelToDeleteIndex] = useState(null);
  const [isDeletePanelModalOpen, setIsDeletePanelModalOpen] = useState(false);

  const [toastMessage, setToastMessage] = useState(null);

  const showToast = (message, type = "success") => {
    setToastMessage({ message, type });
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const panelKey = activePanelIndex.toString();
    const updatedGraphics = reorder(
      graphicsByPanel[panelKey],
      result.source.index,
      result.destination.index
    );

    const updatedStars = reorder(
      graphicStarsByPanel[panelKey],
      result.source.index,
      result.destination.index
    );

    const updatedDimensions = reorder(
      graphicsDimensionsByPanel[panelKey],
      result.source.index,
      result.destination.index
    );

    const newGraphicsByPanel = { ...graphicsByPanel, [panelKey]: updatedGraphics };
    const newGraphicStarsByPanel = { ...graphicStarsByPanel, [panelKey]: updatedStars };
    const newGraphicsDimensionsByPanel = { ...graphicsDimensionsByPanel, [panelKey]: updatedDimensions };

    setGraphicsByPanel(newGraphicsByPanel);
    setGraphicStarsByPanel(newGraphicStarsByPanel);
    setGraphicsDimensionsByPanel(newGraphicsDimensionsByPanel);

    localStorage.setItem("graphicsByPanel", JSON.stringify(newGraphicsByPanel));
    localStorage.setItem("graphicStarsByPanel", JSON.stringify(newGraphicStarsByPanel));
    localStorage.setItem("graphicsDimensionsByPanel", JSON.stringify(newGraphicsDimensionsByPanel));
  };



  const handleAddPainel = () => setIsAddPainelOpen(true);
  const handleClosePainel = () => setIsAddPainelOpen(false);
  const handleOpenAddGraphic = () => setIsAddGraphicOpen(true);
  const handleCloseAddGraphic = () => setIsAddGraphicOpen(false);

  const handleSubmitPainel = (formData) => {
    const updatedPanels = [...panels, { name: formData.nome }];
    setPanels(updatedPanels);

    const newIndex = updatedPanels.length - 1;
    setActivePanelIndex(newIndex);
    localStorage.setItem("activePanelIndex", newIndex);
    localStorage.setItem("panels", JSON.stringify(updatedPanels));

    showToast(`Painel "${formData.nome}" criado com sucesso!`);
    handleClosePainel();
  };

  const handleSubmitGraphic = (formData) => {
    const newGraphic = {
      ...formData,
      id: Date.now().toString() + Math.random().toString(36).substring(2, 9),
    };

    const panelKey = activePanelIndex.toString();

    const updatedGraphics = [...(graphicsByPanel[panelKey] || []), newGraphic];
    const updatedStars = [...(graphicStarsByPanel[panelKey] || []), false];
    const updatedDimensions = [...(graphicsDimensionsByPanel[panelKey] || []), { width: 500, height: 350 }];

    const newGraphicsByPanel = { ...graphicsByPanel, [panelKey]: updatedGraphics };
    const newGraphicStarsByPanel = { ...graphicStarsByPanel, [panelKey]: updatedStars };
    const newGraphicsDimensionsByPanel = { ...graphicsDimensionsByPanel, [panelKey]: updatedDimensions };

    setGraphicsByPanel(newGraphicsByPanel);
    setGraphicStarsByPanel(newGraphicStarsByPanel);
    setGraphicsDimensionsByPanel(newGraphicsDimensionsByPanel);

    localStorage.setItem("graphicsByPanel", JSON.stringify(newGraphicsByPanel));
    localStorage.setItem("graphicStarsByPanel", JSON.stringify(newGraphicStarsByPanel));
    localStorage.setItem("graphicsDimensionsByPanel", JSON.stringify(newGraphicsDimensionsByPanel));

    showToast(`Gráfico "${formData.titulo}" adicionado com sucesso!`);
    handleCloseAddGraphic();
  };

  const handleOpenDeleteGraphic = (index) => {
    setGraphicToDeleteIndex(index);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDeleteGraphic = () => {
    const panelKey = activePanelIndex.toString();
    const deletedGraphic = graphicsByPanel[panelKey][graphicToDeleteIndex];

    const updatedGraphics = [...graphicsByPanel[panelKey]];
    updatedGraphics.splice(graphicToDeleteIndex, 1);

    const updatedStars = [...graphicStarsByPanel[panelKey]];
    updatedStars.splice(graphicToDeleteIndex, 1);

    const updatedDimensions = [...graphicsDimensionsByPanel[panelKey]];
    updatedDimensions.splice(graphicToDeleteIndex, 1);

    const newGraphicsByPanel = { ...graphicsByPanel, [panelKey]: updatedGraphics };
    const newGraphicStarsByPanel = { ...graphicStarsByPanel, [panelKey]: updatedStars };
    const newGraphicsDimensionsByPanel = { ...graphicsDimensionsByPanel, [panelKey]: updatedDimensions };

    setGraphicsByPanel(newGraphicsByPanel);
    setGraphicStarsByPanel(newGraphicStarsByPanel);
    setGraphicsDimensionsByPanel(newGraphicsDimensionsByPanel);

    localStorage.setItem("graphicsByPanel", JSON.stringify(newGraphicsByPanel));
    localStorage.setItem("graphicStarsByPanel", JSON.stringify(newGraphicStarsByPanel));
    localStorage.setItem("graphicsDimensionsByPanel", JSON.stringify(newGraphicsDimensionsByPanel));

    const saved = JSON.parse(localStorage.getItem("starredGraphics") || "[]");
    localStorage.setItem("starredGraphics", JSON.stringify(saved.filter((g) => g.id !== deletedGraphic.id)));

    showToast(`Gráfico "${deletedGraphic.titulo}" excluído com sucesso!`);
    setGraphicToDeleteIndex(null);
    setIsDeleteModalOpen(false);
  };

  const handleOpenDeletePanel = (index, e) => {
    e.stopPropagation();
    setPanelToDeleteIndex(index);
    setIsDeletePanelModalOpen(true);
  };

  const handleConfirmDeletePanel = () => {
    if (panelToDeleteIndex === null) return;

    const updatedPanels = [...panels];
    updatedPanels.splice(panelToDeleteIndex, 1);

    const panelKey = panelToDeleteIndex.toString();

    const shiftKeys = (obj) => {
      const newObj = {};
      Object.keys(obj)
        .map(Number)
        .sort((a, b) => a - b)
        .forEach((key) => {
          if (key > panelToDeleteIndex) {
            newObj[(key - 1).toString()] = obj[key.toString()];
          } else if (key < panelToDeleteIndex) {
            newObj[key.toString()] = obj[key.toString()];
          }
        });
      return newObj;
    };

    const newGraphicsByPanel = shiftKeys({ ...graphicsByPanel });
    const newGraphicStarsByPanel = shiftKeys({ ...graphicStarsByPanel });
    const newGraphicsDimensionsByPanel = shiftKeys({ ...graphicsDimensionsByPanel });

    setPanels(updatedPanels);
    setGraphicsByPanel(newGraphicsByPanel);
    setGraphicStarsByPanel(newGraphicStarsByPanel);
    setGraphicsDimensionsByPanel(newGraphicsDimensionsByPanel);

    localStorage.setItem("panels", JSON.stringify(updatedPanels));
    localStorage.setItem("graphicsByPanel", JSON.stringify(newGraphicsByPanel));
    localStorage.setItem("graphicStarsByPanel", JSON.stringify(newGraphicStarsByPanel));
    localStorage.setItem("graphicsDimensionsByPanel", JSON.stringify(newGraphicsDimensionsByPanel));

    if (activePanelIndex === panelToDeleteIndex) {
      setActivePanelIndex(updatedPanels.length > 0 ? 0 : null);
      localStorage.setItem("activePanelIndex", updatedPanels.length > 0 ? 0 : null);
    } else if (activePanelIndex > panelToDeleteIndex) {
      const newActiveIndex = activePanelIndex - 1;
      setActivePanelIndex(newActiveIndex);
      localStorage.setItem("activePanelIndex", newActiveIndex);
    }

    showToast(`Painel "${panels[panelToDeleteIndex].name}" excluído com sucesso!`);
    setPanelToDeleteIndex(null);
    setIsDeletePanelModalOpen(false);
  };

  const toggleGraphicStar = (index) => {
    const panelKey = activePanelIndex.toString();
    const updated = [...(graphicStarsByPanel[panelKey] || [])];
    updated[index] = !updated[index];

    const graphic = graphicsByPanel[panelKey][index];
    const saved = JSON.parse(localStorage.getItem("starredGraphics") || "[]");

    const updatedStars = {
      ...graphicStarsByPanel,
      [panelKey]: updated,
    };

    setGraphicStarsByPanel(updatedStars);
    localStorage.setItem("graphicStarsByPanel", JSON.stringify(updatedStars));

    if (updated[index]) {
      localStorage.setItem("starredGraphics", JSON.stringify([...saved, graphic]));
      showToast(`Gráfico "${graphic.titulo}" adicionado aos favoritos!`);
    } else {
      localStorage.setItem("starredGraphics", JSON.stringify(saved.filter((g) => g.id !== graphic.id)));
      showToast(`Gráfico "${graphic.titulo}" removido dos favoritos.`, "info");
    }
  };

  const handleSetActivePanel = (index) => {
    setActivePanelIndex(index);
    localStorage.setItem("activePanelIndex", index);
  };

  useEffect(() => {
    const savedPanels = JSON.parse(localStorage.getItem("panels") || "[]");
    const savedGraphics = JSON.parse(localStorage.getItem("graphicsByPanel") || "{}");
    const savedStars = JSON.parse(localStorage.getItem("graphicStarsByPanel") || "{}");
    const savedDimensions = JSON.parse(localStorage.getItem("graphicsDimensionsByPanel") || "{}");
    const savedActivePanelIndex = parseInt(localStorage.getItem("activePanelIndex"), 10);

    setPanels(savedPanels);
    setGraphicsByPanel(savedGraphics);
    setGraphicStarsByPanel(savedStars);
    setGraphicsDimensionsByPanel(savedDimensions);

    if (!isNaN(savedActivePanelIndex)) {
      setActivePanelIndex(savedActivePanelIndex);
    }
  }, []);

  return (
    <div className="flex flex-col md:flex-row gap-6 p-4">
      <div className="w-60 border-r rounded-2xl pr-2">
        <h1 className="my-4 font-semibold">Meus Painéis</h1>
        <Button className="w-full" onClick={handleAddPainel}>Criar painel</Button>
        <div className="space-y-2 mt-4 pt-4 border-t rounded-2xl">
          {panels.map((panel, index) => (
            <div
              key={index}
              className={`flex justify-between items-center px-2 rounded-lg cursor-pointer ${
                activePanelIndex === index ? "text-purple-700 font-semibold" : "text-gray-500 hover:text-[#3f1057]"
              }`}
              onClick={() => handleSetActivePanel(index)}
            >
              <span className="text-sm">{panel.name}</span>
              <button
                className="hover:text-[#ef4444] p-1"
                onClick={(e) => handleOpenDeletePanel(index, e)}
                title="Excluir painel"
                aria-label={`Excluir painel ${panel.name}`}
              >
                <FiTrash size={14} />
              </button>
            </div>
          ))}
        </div>
      </div>

      {panels.length === 0 ? (
        <div className="flex-1 flex items-center justify-center">
            <p className="text-gray-400 text-lg">Nenhum painel criado. Adicione um painel para começar.</p>
        </div>
      ) : (
        activePanelIndex !== null && (
          <div className="flex flex-col w-full">
            <div className="flex items-center mb-8 justify-between">
              <h1 className="text-xl font-bold text-gray-800">
                {panels[activePanelIndex]?.name}
              </h1>
              <Button onClick={handleOpenAddGraphic}>Adicionar gráfico</Button>
            </div>

            <div className="flex flex-wrap gap-6">
              {(graphicsByPanel[activePanelIndex] || []).map((graphic, index) => (
                <GraphicCard
                  key={graphic.id}
                  graphic={graphic}
                  isStarred={graphicStarsByPanel[activePanelIndex]?.[index] || false}
                  onToggleStar={() => toggleGraphicStar(index)}
                  onDelete={() => handleOpenDeleteGraphic(index)}
                  resizable
                  width={graphicsDimensionsByPanel[activePanelIndex]?.[index]?.width || 450}
                  height={graphicsDimensionsByPanel[activePanelIndex]?.[index]?.height || 300}
                  onResize={(e, data) => {
                    const updated = [...(graphicsDimensionsByPanel[activePanelIndex] || [])];
                    updated[index] = { width: data.size.width, height: data.size.height };
                    const newDimensions = {
                      ...graphicsDimensionsByPanel,
                      [activePanelIndex]: updated,
                    };
                    setGraphicsDimensionsByPanel(newDimensions);
                    localStorage.setItem("graphicsDimensionsByPanel", JSON.stringify(newDimensions));
                  }}
                />
              ))}
            </div>
          </div>
        )
      )}

      <AddPanel isOpen={isAddPainelOpen} onClose={handleClosePainel} onSubmit={handleSubmitPainel} />
      <AddGraphic isOpen={isAddGraphicOpen} onClose={handleCloseAddGraphic} onSubmit={handleSubmitGraphic} />

      <FormServiceDelete
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleConfirmDeleteGraphic}
        item={
          graphicToDeleteIndex !== null
            ? graphicsByPanel[activePanelIndex]?.[graphicToDeleteIndex]
            : null
        }
      />

      <FormServiceDelete
        isOpen={isDeletePanelModalOpen}
        onClose={() => setIsDeletePanelModalOpen(false)}
        onConfirm={handleConfirmDeletePanel}
        item={panelToDeleteIndex !== null ? panels[panelToDeleteIndex] : null}
        title="Confirmar exclusão de painel"
        description="Tem certeza que deseja excluir este painel? Essa ação não pode ser desfeita."
        confirmationMessage={
          panelToDeleteIndex !== null
            ? `Você está prestes a excluir o painel \"${panels[panelToDeleteIndex].name}\".`
            : undefined
        }
      />

      {toastMessage && (
        <Toast
          message={toastMessage.message}
          type={toastMessage.type}
          onClose={() => setToastMessage(null)}
        />
      )}
    </div>
  );
};

export default Panel;